import { getCartId } from './actions'
import { useSelector } from './types'

function useHasInCompletedFreeGifts() {
    const gifts = useSelector((state) => state.cart.gifts)
    const hasCart = Boolean(getCartId())

    if (!hasCart || !gifts) {
        return false
    }
    return gifts.some(
        (freeGift) => freeGift.is_available && freeGift.insufficient_amount,
    )
}

export default useHasInCompletedFreeGifts
